import React, { Component } from 'react';
import { Button, Segment, Header, Icon, Dropdown, Item, Divider, Checkbox, Label, Input } from 'semantic-ui-react'
import { folderList } from '../../utils/defaults';
import { getMailContent, getUnreadCount } from '../../utils/rest';
import { List, AutoSizer/*, WindowScroller*/ } from "react-virtualized";
class Mailbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            folderList: folderList,
            text: "Move to: ",
            mailDetail: [],
        };
    }

    openMailContent = (mail, flag) => {
        let params = {
            thread: (mail.msgThread && mail.msgThread > 0 ? mail.msgThread : 0),
            parent: (mail.msgParent && mail.msgParent > 0 ? mail.msgParent : 0),
            read: (flag === 'U' ? true : ""),
            unique: (flag === 'U' ? mail.msrRecId : ""),
            type: this.props.type
        }
        getMailContent(mail.msgId, params).then((response) => {
            if (response != null && (response instanceof Array) && (response.length > 0)) {
                this.props.showEmailContent(true, response, mail.msrRecId, params.read === true);
                if (params.read === true) {
                    getUnreadCount().then((response) => {
                        if (response !== null && response instanceof Object) {
                            this.props.addItem("notification", response);
                        }
                    })
                }
            }
        })
    }

    addToCheckedList = (index, mailId) => {
        let mailCheckedList = this.props.mailCheckedList.slice();
        mailCheckedList[index] = (!mailCheckedList.hasOwnProperty(index)) ? true : !mailCheckedList[index];
        this.props.checkedItemsForDelete(mailId, mailCheckedList[index], mailCheckedList);
    }
    renderHTML = (rawHTML) => React.createElement("p", { dangerouslySetInnerHTML: { __html: rawHTML } });

    renderRow = ({ index, key, style }) => {
        let messageBody = this.props.mails[index].msgBody.replace(/ /g, "\u00a0").substring(0, 50)
        let messageBodySubStringCount = messageBody.lastIndexOf("<") > 0 ? messageBody.lastIndexOf("<") : messageBody.length 
        return (
            <Item.Group key={index} style={style}>
                <Item>
                    <Checkbox label="" checked={this.props.mailCheckedList[index] === true ? true : false} onClick={() => { this.addToCheckedList(index, this.props.mails[index].msrRecId) }} />
                    <Item.Content onClick={() => this.openMailContent(this.props.mails[index], this.props.mails[index].msrFlag)}>
                        <Header as="h4" color={this.props.mails[index].msrFlag === 'U' ? "blue" : "black"} >{this.props.mails[index].usrUserName}</Header>
                        <Item.Description>
                            {this.props.mails[index].msgSubject}
                            <Label color={this.props.mails[index].msrFlag === 'U' ? "blue" : "black"} className="right floated push-up">{this.props.mails[index].msgCreatedAt}</Label>
                        </Item.Description>
                        <Item.Meta>{this.renderHTML(messageBody.substring(0, messageBodySubStringCount))}</Item.Meta>
                    </Item.Content>
                </Item>
                <Divider></Divider>
            </Item.Group>
        );
    }

    render() {
        return (
            <Segment.Group>
                <Segment>
                    <Header as='h5'>{this.props.name}</Header>
                    <Input onKeyDown={this.props.handleSearchKeyDown} ref={this.props.searchBoxRef} value={this.props.searchValue} name="searchValue" onChange={this.props.handleSearchKeyChange} style={{ marginLeft: '528px', width: '589px', height: '37px', marginTop: '-10px' }} icon='search' placeholder='Search...' />
                </Segment>
                <Segment>
                    <Item.Group>
                        <Checkbox label="" checked={this.props.checkAll === true ? true : false} onClick={this.props.setCheckAll} />
                        <Dropdown
                            floating
                            className='right labeled icon small button push-right-15'
                            icon='arrow alternate circle down'
                            text={this.state.text}>
                            <Dropdown.Menu>
                                {
                                    this.state.folderList.map((item, index) => {
                                        return (
                                            <Dropdown.Item key={index} className={(this.props.type === item.key) ? "disabled" : ""} icon={item.icon} text={item.text} onClick={() => this.props.handleMove(item.value)} />
                                        )
                                    })
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                        <Button className="icon small" data-inverted="" data-tooltip="Refresh Inbox" data-position="top right" onClick={this.props.refresh}  >
                            <Icon className='refresh' />
                        </Button>
                        <Button size="small" className="right floated red right labelled" onClick={this.props.handleDelete}>
                            <Icon className='window close' />
                            {this.props.type !== "trash" ? this.props.t("delete.selected") : "Permanently Delete Selected"} ?
                            </Button>
                        <Divider></Divider>
                        <AutoSizer style={{ height: "800px"}}>
                            {({ height, width }) => (
                                <List
                                    height={height-50}
                                    width={width}
                                    rowHeight={100}
                                    rowRenderer={this.renderRow}
                                    rowCount={this.props.mails.length}
                                    style={{ cursor: "pointer" }}
                                />
                            )}
                        </AutoSizer>
                    </Item.Group>
                </Segment>
            </Segment.Group>
        );
    }
}
export default Mailbox;


// WEBPACK FOOTER //
// ./src/app/ui/mails/Mailbox.js